// export const Template = ["HQ-STOCKIST"]
export const Template = [{ id: 1, name: "HQ STOCKIST", value: "HQ-STOCKIST" }];
